import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function obtenerInscripcionesPorColegio(payload) {
  return { type: types.INSCRIPCIONES_POR_COLEGIO, payload };
}

function limpiarInscripcionesPorColegio() {
  return { type: types.RESET_INSCRIPCIONES_POR_COLEGIO };
}

function obtenerInscripcionesDelColegio(payload) {
  return { type: types.INSCRIPCIONES_DEL_COLEGIO, payload };
}

function limpiarInscripcionesDelColegio() {
  return { type: types.RESET_INSCRIPCIONES_DEL_COLEGIO };
}

function obtenerDatosColegio(payload) {
  return { type: types.OBTENER_DATOS_COLEGIO, payload };
}

function limpiarDatosColegio() {
  return { type: types.LIMPIAR_DATOS_COLEGIO };
}

function obtenerDatosInscripcion(payload) {
  return { type: types.OBTENER_DATOS_INSCRIPCION, payload };
}
function limpiarDatosInscripcion() {
  return { type: types.LIMPIAR_DATOS_INSCRIPCION };
}

function aplicarFiltros(payload) {
  return { type: types.APLICAR_FILTROS, payload };
}

function resetFiltros() {
  return { type: types.RESET_FILTROS };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  obtenerInscripcionesPorColegio,
  limpiarInscripcionesPorColegio,
  obtenerInscripcionesDelColegio,
  limpiarInscripcionesDelColegio,
  obtenerDatosColegio,
  limpiarDatosColegio,
  obtenerDatosInscripcion,
  limpiarDatosInscripcion,
  aplicarFiltros,
  resetFiltros
};



// WEBPACK FOOTER //
// ./src/ducks/confirmadas/actions.js